import { formProcessor, validationProcessor } from "./onLoad";
import { FIELDTYPES, STATES, fieldActionConstants } from "../common/constants";
import { getApiValueKeys } from "./helper";
import { sendAnalytics } from "./listeners";
import { closeWebView } from "./utility";

const handleDependencyArray = (dependencyArray) => {
    for(const item of dependencyArray) {
        if(item && item?.fieldSuggestions && item?.sectionId) {
            const data = {
                fieldSuggestions : item.fieldSuggestions,
                updateMandatoryFields : {
                    fieldData : {
                        sectionId : item.sectionId
                    }
                }
            }
            handleFieldSuggestionDependency(data);
        }   
    }
}
const handleFieldSuggestionDependency = (data, objEntity) => {
    const fieldSuggestions = data.fieldSuggestions;
    if(data?.dependencyArray && data.dependencyArray.length > 0) handleDependencyArray(data.dependencyArray)
    const injection = {
        fields: []
    }
    if (fieldSuggestions) {
        try {
            for (const item of fieldSuggestions) {
                if (item) {
                    const fieldId = Object.keys(item)[0];
                    if (fieldId) {
                        if (item[fieldId].value && item[fieldId].options) {
                            formProcessor.updateField({
                                fieldId: fieldId,
                                fieldValue: item[fieldId].value,
                                fieldOptions: item[fieldId].options
                            }, { actionType: fieldActionConstants.UPDATE_ALL });
                        }
                        if (item[fieldId].value) {
                            formProcessor.updateField({
                                fieldId: fieldId,
                                fieldValue: getApiValueKeys(item[fieldId].value)
                            }, { actionType: fieldActionConstants.UPDATE_VALUE });
                            if (item[fieldId]?.metric?.fireAnalytics) {
                                const fieldData = formProcessor.getField(fieldId);
                                sendAnalytics(fieldData?.fieldData || fieldData, {
                                    metric: {
                                        eventValue: getApiValueKeys(item[fieldId].value),
                                        prop26: "auto"
                                    }
                                });
                            }
                            if (item[fieldId]?.metric?.validateField) {
                                const fieldValue = getApiValueKeys(item[fieldId].value);
                                const fieldData = formProcessor.getField(fieldId);
                                const errorInfo = validationProcessor.validateField({
                                    fieldId: fieldId,
                                    fieldValue: fieldValue,
                                    fieldData: fieldData?.fieldData || fieldData,
                                    type: "default"
                                });
                                formProcessor.updateField({
                                    fieldId: fieldId,
                                    fieldValue: fieldValue,
                                    metric:{},
                                    errorInfo: errorInfo
	                            }, { actionType: fieldActionConstants.UPDATE_ERRORINFO });
                            }
                        }
                        if (item[fieldId].options) {
                            formProcessor.updateField({
                                fieldId: fieldId,
                                fieldOptions: item[fieldId].options
                            }, { actionType: fieldActionConstants.UPDATE_OPTIONS });
                        }
                        if (item[fieldId].attributes) {
                            if(item[fieldId].attributes?.mandatoryInject == undefined) injection.fields.push(fieldId);
                            if(item[fieldId].attributes.mandatoryInject && item[fieldId].attributes.mandatoryInject !== "no") injection.fields.push(fieldId);
                            formProcessor.updateField({
                                fieldId: fieldId,
                                attributes: item[fieldId].attributes
                            }, { actionType: fieldActionConstants.UPDATE_ATTRIBUTES });
                            if(item[fieldId].attributes?.dependantField && item[fieldId].attributes?.dependantFieldArray) formProcessor.updateParentField(item[fieldId].attributes?.dependantField, item[fieldId].attributes?.dependantFieldArray);
                        }
                        if (item[fieldId].filter) {
                            formProcessor.updateField({
                                fieldId: fieldId,
                                filter: item[fieldId].filter
                            }, { actionType: fieldActionConstants.ENABLE_FILTER });
                        }
                        if (item[fieldId].checked) {
                            const value = getApiValueKeys(item[fieldId].checked)
                            formProcessor.updateField({
                                fieldId: fieldId,
                                checked: (value === 'checked'),
                                fieldValue: value,
                            }, { actionType: fieldActionConstants.UPDATE_CHECKED });
                        }
                        if (item[fieldId].resetAndRemoveFields) {
                            formProcessor.deleteFieldUsingAppendById(fieldId)
                            const field = formProcessor.getField(fieldId)
                            if (field.resetFields) {
                                field.resetFields()
                            }
                        }
                        if (item[fieldId].reset) {
                            const field = formProcessor.getField(fieldId)
                            field.resetFields && field.resetFields()
                        }
                        if (item[fieldId].updateTitle) {
                            const section = formProcessor.getSection(formProcessor.getActiveSection());
                            section && section.updateTitle && section.updateTitle();
                        }
                        if (item[fieldId].resetTitle) {
                            const section = formProcessor.getSection(formProcessor.getActiveSection());
                            section && section.resetTitle && section.resetTitle();

                        }
                        if (item[fieldId].incrementInLocalStorage) {
                            const values = Object.keys(item[fieldId].incrementInLocalStorage);
                            for (const key of values) {
                                const oldValue = localStorage.getItem(key);
                                if (oldValue) {
                                    const newValue = Number(item[fieldId].incrementInLocalStorage[key]) + Number(oldValue);
                                    localStorage.setItem(key, newValue)
                                }
                                else {
                                    localStorage.setItem(key, item[fieldId].incrementInLocalStorage[key])
                                }
                            }
                        }
                        if (item[fieldId].closeWebViewOnRetriesLimit) {
                            const values = Object.keys(item[fieldId].closeWebViewOnRetriesLimit);
                            for (const key of values) {
                                const val = localStorage.getItem(key);
                                if (val && val == item[fieldId].closeWebViewOnRetriesLimit[key]) {
                                    closeWebView();
                                }
                            }
                        }
                    }
                }
            }
            if (objEntity?.flag) {
                mandatoryFieldInjection(objEntity.entity, injection)
            }
            if (data?.updateMandatoryFields) {
                mandatoryFieldInjection(data.updateMandatoryFields, injection)
            }
        } catch (err) {
            console.error();
        }
    }
}

const errorInfoStatus = (entity) => {
    if (!entity?.errorInfo || (entity?.errorInfo && entity?.errorInfo?.state === STATES.NONE)) return true;
    else return false;
}

const setValueFieldStatus = (fieldId, entity) => {
    const errorStatus = errorInfoStatus(entity);
    if (errorStatus) {
        if (entity.checked) formProcessor.setValueFieldStatus(fieldId, true);
        if (entity.type === FIELDTYPES.CHECKBOX) {
            if (entity.value !== "checked" && !entity.checked) formProcessor.setValueFieldStatus(fieldId, false);
        }
        else {
            if ((entity.value !== "" && entity.value !== undefined) || (entity.updatedValue !== "" && entity.updatedValue !== undefined)) formProcessor.setValueFieldStatus(fieldId, true);
            else formProcessor.setValueFieldStatus(fieldId, false);
        }
    }
    else formProcessor.setValueFieldStatus(fieldId, false);
}

const indicateDependentFields = (fieldData) => {

    const dependantFields = fieldData?.dependantFields || fieldData?.attributes?.dependantFields;
    const depAttributeFlag = (!fieldData?.dependantFields && fieldData?.attributes?.dependantFields) ? true : false;
    if (dependantFields) {
        dependantFields.forEach((item) => {
            const updateParentField = depAttributeFlag ? fieldData?.attributes?.dependantFieldArray : [];
            const allValueValid = checkParentFields(item, updateParentField);
            formProcessor.updateField({
                fieldId: item,
                attributes: { disabled: !allValueValid.fieldData ? false : !allValueValid.bool }
            }, { actionType: fieldActionConstants.UPDATE_ATTRIBUTES })
        })
    }
}

const checkParentFields = (fieldId, updateParentField = []) => {
    const field = formProcessor.getField(fieldId);
    if (field?.parentFields) {
        field.parentFields = field.parentFields.concat(updateParentField);
        for (let i = 0; i < field.parentFields.length; i++) {
            if (!formProcessor.getValueFieldStatus(field.parentFields[i])) {
                return { fieldData: field, bool: false };
            }
        }
        return { fieldData: field, bool: true };
    }
    return { fieldData: field, bool: false };
}

const mandatoryFieldInjection = (entity, injection) => {
    formProcessor.updateMandatoryFields(entity.fieldData.sectionId, injection.fields);
}

export {
    handleFieldSuggestionDependency,
    indicateDependentFields,
    setValueFieldStatus,
    checkParentFields
}